module.exports = __webpack_public_path__ + "img/issued-account.55805e18.svg";